<template>
  <!-- test -->
  <div v-if="hid" class="testI18n">
    <span @click="test('zh-cn')">中</span>
    <span @click="test('en-us')">英</span>
  </div>
  <!-- test -->
</template>

<script>
export default {
  inject: ['root'],
  data() {
    return {
      hid: false
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') {
      this.hid = true
    } else {
      this.hid = false
    }
  },
  methods: {
    test(localeval) {
      this.$i18n.locale = localeval
      this.root.changeLocale(localeval)
    }
  }
}
</script>

<style lang="less" scoped>
.testI18n{
	position: absolute;
	left: 50%;
}
</style>



// WEBPACK FOOTER //
// src/component/testCheckI18n.vue